
   import Vue from 'vue'
   import { Dropdown, Btn } from 'uiv'

   export default Vue.extend({
      props: {
         value: { type: Array as () => string[], default: () => [] },
         initial:{ type: Array as () => string[], default: () => [] },
         size: { type: String, default: 'btn-sm' },
         type: { type: String, default: 'btn-outline' },
         nonSelectedText: { type: String, default: 'None selected' },
         allSelectedText: { type: String, default: 'All selected' },
         showSelectAll: { type: Boolean, default: false },
         showSearch: { type: Boolean, default: false },
         maxSelections: { type: Number, default: 3 },
         options: { type: Array as () => NameValuePair[], default: () => [] },
      },
      data() {
         return {
            initialValue: [] as string[],
            innerValue: [] as string[],
            dirty: false,
            show: false,
            elements: [] as any[],
            searchText: '',
         }
      },
      computed: {
         filteredOptions(): NameValuePair[] {
            if (!this.showSearch) {
               return this.options
            }
            if (this.searchText.length === 0) {
               return this.options
            }
            return this.options.filter(opt => opt.name.indexOf(this.searchText) > -1)
         },
         allAreSelected(): boolean {
            return this.innerValue.length === this.options.length
         },
         selectedText(): string {
            if (this.innerValue.length === 0) {
               return this.$t(this.nonSelectedText) as string
            }
            if (this.innerValue.length <= this.maxSelections) {
               return this.selectedItemNames.join(', ')
            }
            if (this.allAreSelected) {
               return `${this.$t(this.allSelectedText)} (${this.innerValue.length})`
            }
            return `${this.innerValue.length} selected`
         },
         selectedItemNames(): string[] {
            return this.innerValue
               .map(selectedValue => {
                  const item = this.options.find(opt => opt.value === selectedValue)
                  return item ? item.name : ''
               })
               .filter(name => !!name)
         },
      },
      mounted() {
         if (this.value && this.value.length > 0) {
            this.innerValue = this.value
            this.initialValue = this.value
         } else if (this.initial) {
            this.innerValue = this.initial
            this.initialValue = this.initial
         }
         const elementId = (this.$refs.dropdown as any).$el
         this.elements.push(elementId)
      },
      methods: {
         toggleSelectAll() {
            if (this.allAreSelected) {
               this.innerValue = []
            } else {
               this.innerValue = this.options.map(opt => opt.value as string)
            }
         },
         optionIsSelected(optionValue: string): boolean {
            const match = this.innerValue.find(selectedValue => selectedValue === optionValue)
            return !!match
         },
         clearSearch() {
            this.searchText = ''
         },
      },
      watch: {
         options() {
            // If our options change, we have to remove any selected values that are no longer valid
            this.innerValue = this.innerValue.filter(selectedValue => {
               const match = this.options.find(opt => opt.value === selectedValue)
               return !!match
            })
         },
         value(newValue: string[]) {
            // Update our inner value if the bind source data changes
            if (!this.innerValue.containsSameElementsAs(newValue)) {
               this.innerValue = newValue
               this.initialValue = newValue
            }
         },
         innerValue(event: any) {
            this.$emit('input', this.innerValue)
            this.$emit('change', this.innerValue)
         },
      },
      components: {
         Dropdown,
         Btn,
      },
   })
